import React, { useState } from "react";
import Header from "../../../components/UserComponents/Header";
import Footer from "../../../components/UserComponents/Footer";
import { KeyRound, LoaderCircle } from "lucide-react";
import { useFormik } from "formik";
import { USER_URL } from "../../../constants";
import { Button, Text } from "../../../components/UserComponents";
import showToast from "../../../utils/showToast";
import { axiosPublicInstance } from "../../../utils/api/axiosInstance";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { Img } from "../../../components/UserComponents";

const ForgotPassword = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      setIsSubmitting(true);
      axiosPublicInstance
        .post(USER_URL + `/forgot-password`, values)
        .then(() => {
          showToast("Reset link shared to your email");
        })
        .catch(({ response }) => showToast(response.data.message, "error"))
        .finally(() => setIsSubmitting(false));
    },
  });
  return (
    <>

      <div className="bg-slate-50 h-screen flex justify-center items-center flex-col">
          <div className="container  m-auto">
            <div className="bg-slate-50 rounded-2xl overflow-hidden shadow-lg  w-4/5 md:w-full mx-auto md:shadow-none">
              <div className="grid grid-cols-2 md:grid-cols-1 ">
                <Link to="/"><Img src="/images/black-friday.png"  alt="blackfriday" className="h-full md:hidden"/></Link>
                <div className="flex flex-col items-center gap-0 p-10 md:p-3 w-full justify-center">
                <div className="w-full">
        <div className="flex items-center gap-1 mb-3">
          <h2 className="text-4xl font-bold text-gray-800 pr-5 ">
            Forgot password
          </h2>
          <KeyRound className="size-8 " />
        </div>
        <p className="text-sm font-medium text-gray-500 mb-10">
          Enter the email to recover password
        </p>
        <form className="space-y-2 mt-1" onSubmit={formik.handleSubmit}>
          <label htmlFor="email" className="text-sm font-bold text-gray-800">
            Email
          </label>
          
            <input
              type="text"
              className="w-full !shadow-none !border-none !bg-gray-100 h-[50px] !rounded-md !px-3"
              placeholder="johndoe@gmail.com"
              {...formik.getFieldProps("email")}
            />
          
          {formik.touched.email && formik.errors.email && (
            <Text className="text-red-500" size="s">
              {formik.errors.email}
            </Text>
          )}
          <div className="flex justify-center items-center pt-10">
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-20 py-2 w-full justify-center  inline-flex gap-1 text-white-A700 font-medium bg-thdark rounded-3xl  transition duration-75 "
            >
              {isSubmitting ? (
                <LoaderCircle className="size-5 animate-spin" />
              ) : (
                <span>Submit</span>
              )}
            </button>
          </div>
        </form>
        <div className="flex justify-center mt-10">
          <Link to="/login" className="text-sm text-gray-400 font-medium">
            Go back to login
          </Link>
        </div>
      </div>

                </div>

              </div>
            </div>
          </div>
          </div>


 
     

    </>
  );
};

export default ForgotPassword;
